module.exports = __webpack_public_path__ + "static/media/id.9e3da56e.svg";